import { CpuModule } from 'game/state/BotState';
import { Processor } from '../Processor';

export const cpuProcessor: Processor<CpuModule> = (module, ctx) => {
  const { cpu } = module.inputs;
  const { modules } = ctx.bot.props.state;
  const cmd = cpu && modules.find(m => m.id === cpu.moduleId);
  if (!cmd) return { status: 'null' };
  return ctx.processOther(cmd, ctx);
};
